import { supabase } from "@/supabase";

export async function deletarPlano(id){
    let { data: dataGrupo, errorGrupo } = await supabase
        .from('grupos_planos')
        .select('*')
        .eq('plano', id)



    let { data, error } = await supabase
        .from('planos')
        .delete()
        .eq('id', id)

    if (error) {
        alert('Ocorreu um erro ao excluir o plano. Recarregue a página e tente novamente.')
        return false;
    }

   

   


    console.log(dataGrupo);

    if(dataGrupo.length > 0){
        let { errorDeletarGrupos } = await supabase
            .from('grupos')
            .delete()
            .in('id', dataGrupo.map(item => item.grupo))


        if (errorDeletarGrupos) {
            alert('Ocorreu um erro ao excluir os grupos desse plasse plano. Exclua os grupos individualmente se for possível.');
            return false;
        }
    }
    

    return true
}


export async function loadPlanoPorId(idDoPlano){
    console.log(idDoPlano);
    const {data, error} = await supabase
    .from('planos_avaliacoes')
    .select('*')
    .eq('plano', parseInt(idDoPlano))


    if(error){
        console.log(error);
        return false;
    }
    console.log(data);
    return data;
}